module.exports = __webpack_public_path__ + "static/media/hisoka.83030bfd.jpeg";